import { Button, type ButtonProps } from "@octopus-energy/coral/atoms"
import { useActionsContext } from "../../../contexts/actions-context"

export function ActionsSkip({ children, disabled, ...props }: ButtonProps) {
    const { loading, step } = useActionsContext()

    return (
        <Button
            disabled={disabled || loading}
            variant="outlined"
            color="primary500"
            attributes={{ "data-testid": "skipButton" }}
            {...props}
        >
            {children ?? (step ? "Je passe cette étape" : "Passer")}
        </Button>
    )
}
